import { call } from "redux-saga/effects";
import { API_URL } from "../_config";
import { CallApi } from "./api/callApi";

export function* getJobseekers(action: any): any {
  try {
    const { params = {} } = action.payload || {};

    const url = API_URL.CANDIDATES.GET_JOBSEEKERS;
    const resp = yield call(CallApi.GET, url, params, true);

    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* getJobseekersAdvanced(action: any): any {
  try {
    const { params = {} } = action.payload || {};

    const url = API_URL.CANDIDATES.GET_JOBSEEKERS_ADVANCED;
    const resp = yield call(CallApi.GET, url, params, true);

    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* saveCandidate(action: any): any {
  try {
    const data = action.payload || {};
    const resp = yield call(CallApi.POST, API_URL.SAVED_CANDIDATES.SAVE, data, true);
    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* unsaveCandidate(action: any): any {
  try {
    const data = action.payload || {};
    const resp = yield call(CallApi.POST, API_URL.SAVED_CANDIDATES.UNSAVE, data, true);
    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* listSavedCandidates(action: any): any {
  try {
    const resp = yield call(CallApi.GET, API_URL.SAVED_CANDIDATES.LIST, {}, true);
    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* searchUnlock(action: any): any {
  try {
    const data = action.payload || {};
    const resp = yield call(CallApi.POST, API_URL.CANDIDATES.SEARCH_UNLOCK, data, true);

    if (resp.status >= 200 && resp.status < 300) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* sourceExternalAdvanced(action: any): any {
  try {
    const data = action.payload || {};
    const resp = yield call(CallApi.POST, API_URL.CANDIDATES.SOURCE_EXTERNAL, data, true);

    if (resp.status >= 200 && resp.status < 300) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* sourceExternalAdvancedStatus(action: any): any {
  try {
    const { runId, params = {} } = action.payload || {};
    const url = `${API_URL.CANDIDATES.SOURCE_EXTERNAL_STATUS}/${runId}`;
    const resp = yield call(CallApi.GET, url, params, true);

    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}
